<template>
  <div class="pageIntro">
    <h2>Jennifer Baldwin</h2>
    <div class="niches">
      <!-- Shortcut these to specific portfolios -->
      <h3>Developer</h3>
      <h3>+</h3>
      <h3>Designer</h3>
      <h3>+</h3>
      <h3>Photographer</h3>
    </div>
  </div>
  <div class="directions">
    <router-link v-for="pic in pics" :key="pic.link" v-bind:to="`/${pic.link}`" @click="updateTitle(pic.link)"
      class="photoBoxes">
      <polaroid-pic class="photoBox" :alt="pic.alt" :imgFile="pic.imgFile" :caption="pic.caption"></polaroid-pic>
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pics: [
        {
          link: "about",
          imgFile: "aboutSQ.jpg",
          caption: "My Bio",
          alt: "RMNP along Old Fall River Road, CO. Mt. Julian, Mt. Ida, and Sprague Mountain in the background. Jennifer stands with her back to the camera overlooking a valley of pine trees and mountains as a strong wind rushes up the mountainside.",
        },
        {
          link: "portfolio",
          imgFile: "portraitSQ.jpg",
          caption: "See Projects",
          alt: "A headshot of Jennifer smiling woman with long brown hair, wearing glasses and a mustard-yellow sweater over a collared shirt. She is standing in the rotunda of Indiana's a state capitol building, with the blurred architectural details of arches and a dome visible in the background.",
        },
        {
          link: "contact",
          imgFile: "contactSQ.jpg",
          caption: "Lets Talk",
          alt: "Jennifer stands a graduate, smiling while leaning on a railing in a modern building with large windows. She has long brown hair and is wearing glasses, a lace dress, a strand of pearls, and a dark red graduation stole. She holds a matching red diploma folder in her hands.",
        },
      ],
    };
  },
  emits: ["updateTitle"],
  props: {
    pTitle: String,
  },
  methods: {
    updateTitle(newTitle) {
      this.$emit("updateTitle", newTitle);
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: inherit;
}

/* Index styles */
.directions {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: auto 0;
}

.directions .photoBoxes {
  width: 28%;
  /* max-height: 100%; */
}

/* Mobile */
@media only screen and (max-width: 560px) {
  .directions {
    flex-direction: column;
  }

  .directions .photoBoxes {
    width: 70%;
    font-size: 20px;
    margin-bottom: 30px;
  }
}

/* END Index styles */
</style>
